import React from 'react';

import { createDashboardTableClassName } from './dashboardTableStyles';

export const DashboardTableCell: React.FC = ({ children }) => (
  <div className={createDashboardTableClassName('cell')}>{children}</div>
);
